module.exports = __webpack_public_path__ + "static/media/pie.19d4a321.png";